import React from "react";
import { trans } from "../../helpers/index";
import config from "../../baseConfig/index";
import { Cookies } from "react-cookie";

export default (props) => {
  let reload = "";

  if (props.hasOwnProperty("trans")) {
    reload = (
      <p>
        {trans(props.trans, "reload.text1")}
        <button
          className="form-error-link fs11"
          type="button"
          onClick={() => {
            let browserCookies = new Cookies();
            browserCookies.remove("loginToken", { path: config.urlPrefix });
            window.location.reload();
          }}
        >
          {trans(props.trans, "reload.text2")}
        </button>
        {trans(props.trans, "reload.text3")}
      </p>
    );
  }

  return (
    <div className="form__form-box form-error tc">
      <div className="form-error-text fs11">
        {props.message}
        {reload}
      </div>
    </div>
  );
};
